import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListSynopsisText = styled.div<{ bold?: boolean }>`
  color: ${Colors['text']};
  display: -webkit-box;
  font-family: ${(props) => (props?.bold ? Fonts['bold'] : Fonts['light'])};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${50 * Screen.widthRatio}px;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;

export default ChannelListSynopsisText;
